module.exports = __webpack_public_path__ + "img/kodefast-Logo-Black.384aef8f.png";